import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-supply-chain-inventory-turnover-calculator',
  templateUrl: './supply-chain-inventory-turnover-calculator.component.html',
  styleUrls: ['./supply-chain-inventory-turnover-calculator.component.css']
})
export class SupplyChainInventoryTurnoverCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  invenTurn(n1,n2){
    var invenTur=(n1)/n2;
    var invenTursimple= invenTur.toFixed(2);
    return invenTursimple ;
    }

}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/supply-chain-inventory-turnover-calculator/supply-chain-inventory-turnover-calculator.component.ts